import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";
import styled from "styled-components";
import { COLORS } from "../../../const/colors";

export const HeaderNav = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${(props) =>
    props.scrollNav
      ? props.light
        ? COLORS.BLACK_80
        : COLORS.WHITE_80
      : "transparent"};
  box-shadow: ${(props) =>
    props.scrollNav
      ? props.light
        ? "0 4px 20px rgba(0, 0, 0, 0.3)"
        : "0 4px 20px rgba(0, 0, 0, 0.1)"
      : "none"};
  backdrop-filter: ${(props) => (props.scrollNav ? "blur(10px)" : "none")};
  z-index: var(--z-navbar);
  transition: all 0.3s ease;
`;

export const NavContainer = styled.nav`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: 992px) {
    height: 5rem;
  }
`;

export const NavLogo = styled(LinkS)`
  color: ${COLORS.ORANGE};
  font-weight: 700;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: -0.5px;

  &:first-child {
    &:hover {
      color: ${COLORS.DARK_BLUE};
      transform: scale(1.05);
    }
  }

  &:last-child {
    font-size: 0.9rem;
    padding: 0.5rem 0.9rem;
    background: linear-gradient(
      to right,
      ${COLORS.ORANGE_10},
      ${COLORS.ORANGE_20}
    );
    border-radius: 2rem;
    border: 1px solid ${COLORS.ORANGE_20};
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(
        to right,
        ${COLORS.ORANGE_20},
        ${COLORS.ORANGE_30}
      );
      transform: translateY(-2px);
      box-shadow: 0 4px 8px ${COLORS.ORANGE_15};
    }
  }
`;

export const NavMenu = styled.div`
  position: fixed;
  bottom: 1.5rem;
  background-color: ${(props) =>
    props.light ? COLORS.DARK_BLUE_80 : COLORS.WHITE_80};
  width: 90%;
  max-width: 400px;
  border-radius: 4rem;
  padding: 1rem 2.25rem;
  backdrop-filter: blur(30px);
  left: 0;
  right: 0;
  margin: 0 auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid
    ${(props) => (props.light ? COLORS.WHITE_10 : COLORS.BLACK_10)};
  z-index: 999;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  @media screen and (max-width: 320px) {
    padding: 1rem 1.5rem;
  }
`;

export const NavList = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NavItem = styled.li`
  list-style: none;
`;

export const NavLink = styled(LinkS)`
  color: ${(props) => (props.light ? COLORS.LIGHT_GRAY : COLORS.DARK_BLUE)};
  padding: 0.5rem;
  display: flex;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.25rem;
  transition: all 0.3s ease;

  i {
    transition: all 0.3s ease;
  }

  &:hover {
    color: ${(props) => (props.light ? COLORS.WHITE : COLORS.BLACK)};

    i {
      transform: translateY(-3px);
    }
  }

  &.active {
    background: linear-gradient(180deg, ${COLORS.ORANGE}, ${COLORS.ORANGE_50});
    box-shadow: 0 0 16px ${COLORS.ORANGE_30};
    color: ${(props) => (props.light ? COLORS.WHITE : COLORS.BLACK)};
    transform: translateY(-5px);
  }
`;

export const ThemeIcon = styled.div`
  font-size: 1.25rem;
  transition: 0.3s;
  color: ${COLORS.ORANGE};
  cursor: pointer;

  &:hover {
    color: ${COLORS.DARK_BLUE};
  }
`;

export const ButtonLogin = styled(LinkR)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.ORANGE};
  color: ${COLORS.WHITE};
  padding: 0.75rem 1.25rem;
  border-radius: 0.75rem;
  font-weight: 500;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 10px ${COLORS.ORANGE_30};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${COLORS.WHITE_30},
      transparent
    );
    transition: all 0.6s ease;
  }

  &:hover {
    background-color: ${COLORS.DARK_BLUE};
    transform: translateY(-3px);
    box-shadow: 0 6px 15px ${COLORS.DARK_BLUE_30};

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px ${COLORS.ORANGE_30};
  }

  &:disabled {
    background-color: ${COLORS.LIGHT_GRAY};
    cursor: not-allowed;
    box-shadow: none;

    &:hover {
      transform: none;
    }
  }
`;
